import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { useAppDispatch } from '../redux/hooks';
import { updateSearchedUserProfile, fetchSearchedUser } from '../redux/SearchedUserReducer/searchedUserSlice';
import { ActivityLogEventActions } from '../constants/activityLogEventActions';
import { isInactiveStatus } from '../utils/statusChipConfig';

export const useUserStatus = (user: any, displayUser: any) => {
    const dispatch = useAppDispatch();
    const [userStatus, setUserStatus] = useState("");

    useEffect(() => {
        if (displayUser) {
            setUserStatus(displayUser?.status || '');
        }
    }, [displayUser]);

    const handleToggleStatus = async () => {
        if (!user) {
            toast.error("User data not available");
            return;
        }

        const currentStatus = displayUser?.status || userStatus;
        const newStatus = isInactiveStatus(currentStatus) ? "ACT" : "INA";
        const actionText = newStatus === "ACT" ? "activate" : "deactivate";
        const eventAction = newStatus === "ACT"
            ? ActivityLogEventActions.UserActivated
            : ActivityLogEventActions.UserDeactivated;

        try {
            await dispatch(updateSearchedUserProfile({
                workdayId: user.workdayId,
                firstName: user.firstName,
                lastName: user.lastName,
                status: newStatus,
                eventAction: [eventAction]
            })).unwrap();

            toast.success(`User ${actionText}d successfully!`);
            setUserStatus(newStatus);
            dispatch(fetchSearchedUser(user.workdayId));
        } catch (error) {
            console.error(`Error ${actionText}ing user:`, error);
            toast.error(`Failed to ${actionText} user`);
        }
    };

    const effectiveStatus = displayUser?.status || userStatus;
    const statusActionLabel = isInactiveStatus(effectiveStatus) ? "Activate User" : "Deactivate User";

    return {
        userStatus,
        setUserStatus,
        effectiveStatus,
        statusActionLabel,
        handleToggleStatus,
    };
};